import ActionHelper from '@module/redux-actions';
import Privacy from '@app/modules/privacy';

import {
  consentManager,
  consentModel,
  consentTracker,
} from '@module/consent-manager';

export const actions = ActionHelper.types([
  'SET_TRANSPARENCY_CONSENT_STRING',
  'SET_TRANSPARENCY_CONSENT_UI_VISIBLE',
]);

export default ActionHelper.generate({
  acceptAll(context) {
    consentManager.acceptAll();
    consentTracker.acceptAll(context);
    const tcString = consentModel.getTCString();

    // We're not using this to determine wallpaper provider but we are using
    // this to indirectly load SDKs for now.
    Privacy.acceptTrackers();

    return { type: actions.SET_TRANSPARENCY_CONSENT_STRING, tcString };
  },

  rejectAll(context) {
    consentManager.rejectAll();
    consentTracker.rejectAll(context);
    const tcString = consentModel.getTCString();

    Privacy.declineTrackers();

    return { type: actions.SET_TRANSPARENCY_CONSENT_STRING, tcString };
  },

  save(context) {
    consentManager.save();
    consentTracker.save(context);
    const tcString = consentModel.getTCString();

    // In the interest of time, if a does not give full consent, we treat this
    // as "rejected".
    if (!consentModel.hasFullConsent()) {
      Privacy.declineTrackers();
    }

    return { type: actions.SET_TRANSPARENCY_CONSENT_STRING, tcString };
  },

  setUIVisible(uiVisible) {
    return {
      type: actions.SET_TRANSPARENCY_CONSENT_UI_VISIBLE,
      uiVisible,
    };
  },
});
